/**
 * Compass type enum
 * @enum {string}
 */
export enum CompassTypeEnum {
    LIGHT = "light",
    DARK = "dark"
}
